export class ContactAddressModel{


    /// <remarks/>
    addressLine1: string;

    /// <remarks/>
    addressLine2: string;

    /// <remarks/>
    addressLine3: string;

    /// <remarks/>
    addressType: string;

    /// <remarks/>
    //auditModel: SimpleAuditModel;

    /// <remarks/>
    city: string;

    /// <remarks/>
    //contactAddressPK: ContactAddressPKModel;

    /// <remarks/>
    countryCode: string;

    /// <remarks/>
    effectiveDate: Date;

    /// <remarks/>
    entityID: number;

    /// <remarks/>
    entityType: string;

    /// <remarks/>
    expirationDate: Date;

    /// <remarks/>
    fax: string;

    /// <remarks/>
    faxCountryCode: string;

    /// <remarks/>
    fullAddress: string;

    /// <remarks/>
    houseNumberEnd: number;

    /// <remarks/>
    houseNumberStart: number;

    /// <remarks/>
    orderBy: string;

    /// <remarks/>
    phone: string;

    /// <remarks/>
    phoneCountryCode: string;

    /// <remarks/>
    primary: string;

    /// <remarks/>
    recipient: string;

    /// <remarks/>
    state: string;

    /// <remarks/>
    streetDirection: string;

    /// <remarks/>
    streetName: string;

    /// <remarks/>
    streetPrefix: '';

    /// <remarks/>
    streetSuffix: string;

    /// <remarks/>
    streetSuffixDirection: string;

    /// <remarks/>
    unitEnd: string;

    /// <remarks/>
    unitStart: string;

    /// <remarks/>
    unitType: string;

    /// <remarks/>
    zip: string;

    /// <remarks/>
    levelPrefix: string;

    /// <remarks/>
    levelNumberStart: string;

    /// <remarks/>
    levelNumberEnd: string;

    /// <remarks/>
    houseNumberAlphaStart: string;

    /// <remarks/>
    houseNumberAlphaEnd: string;

    /// <remarks/>
    replaceAddressID: number;

    /// <remarks/>
    validateFlag: string;
}
